import { AloftPrice } from '@aloft/toolkit-shared';

import { AdditionalFeatureKey, SalesComparisonGridColumnData } from '../types.ts';

export const getSalesComparisonNestedValue = (
  obj: SalesComparisonGridColumnData | null,
  path: keyof SalesComparisonGridColumnData | AdditionalFeatureKey,
): string | undefined => {
  if (!obj) return undefined;

  const parts = (path as string).split('.');

  let value: any = obj;
  parts.forEach((part) => {
    value = value?.[part];
  });

  if (value instanceof AloftPrice) return value.toString(true);
  return value as string;
};
